import React from "react";
import { Link } from "react-router-dom";
import Image from "./Image";
import PROJECTS from "../projects";
import Masonry from "react-masonry-css";

const renderImages = (projects) =>
  projects.map((project, index) => (
    <Link key={index} to={`/projects/${project.name}`}>
      <Image
        alt={project.name}
        src={`/assets/projects/${project.name}/main.jpg`}
        srcSmall={`/assets/projects/${project.name}/main-min.jpg`}
      />
    </Link>
  ));

const breakpointColumnsObj = {
  default: 3,
  1000: 2,
  600: 1,
};

const Gallery = () => (
  <Masonry
    breakpointCols={breakpointColumnsObj}
    className="my-masonry-grid"
    columnClassName="my-masonry-grid_column"
  >
    {renderImages(PROJECTS)}
  </Masonry>
);

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/Gallery.jsx